<template>
  <div>
    <div class="mouse-menu" @contextmenu.prevent v-if="mouseMenuVisible"
      :style="{ left: menuPosition.x + 'px', top: menuPosition.y + 'px' }" @click="handleClick($event)">
      <div class="mouse-function" v-if="rightMenuType === 'main'">
        <span class="iconfont">&#xe6c0;</span>
        <span>下载图片</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe6c0;</span>
        <span>下载图片</span>
      </div>
      <div class="mouse-function" v-if="rightMenuType === 'main'">
        <span class="iconfont">&#xe671;</span>
        <span>收藏图片</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe671;</span>
        <span>收藏图片</span>
      </div>
      <div class="mouse-function" v-if="rightMenuType === 'main'">
        <span class="iconfont">&#xe64a;</span>
        <span>复制图片</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe64a;</span>
        <span>复制图片</span>
      </div>
      <div class="mouse-function" v-if="rightMenuType === 'main'">
        <span class="iconfont">&#xe85f;</span>
        <span>用作修改</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe85f;</span>
        <span>用作修改</span>
      </div>
      <div class="mouse-function" v-if="rightMenuType === 'main'">
        <span class="iconfont">&#xe679;</span>
        <span>用作参考</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe679;</span>
        <span>用作参考</span>
      </div>
      <div class="mouse-function" v-if="rightMenuType === 'dock'">
        <span class="iconfont">&#xe6c9;</span>
        <span>嵌入画板</span>
      </div>
      <div class="mouse-function-dock" v-else>
        <span class="iconfont">&#xe6c9;</span>
        <span>嵌入画板</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightMenu',
  data() {
    return {
      methodsfunction: null,
      menuType: 'main'
    }
  },
  props: {
    mouseMenuVisible: {
      type: Boolean,
      default: true
    },
    menuPosition: {
      type: Object,
      default: () => {
        return {
          x: 0,
          y: 0
        }
      }
    },
    rightMenuType: {
      type: String,
      default: 'main'
    }
  },
  watch: {
  },
  mounted() {
    window.addEventListener('keydown', this.handleEsc)
  },
  methods: {
    // 点击方法和功能
    handleClick(event) {
      const res = event.target.closest('.mouse-function')
      if (res) {
        const span = res.querySelector('span:nth-child(2)')
        this.$emit('clickfunction', span.textContent)
        this.closeModal()
      }
    },

    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
      if (event.shiftKey && event.key === 'E') {
        this.closeModal()
      }
    },
    // 关闭窗口
    closeModal() {
      this.$emit('update:mouseMenuVisible', false)
    }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEsc)
  }

}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mouse-menu {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 200px;
  height: 350px;
  padding: 15px;
  background: @font_white;
  border-radius: @border_radius_2;
  z-index: 101;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);
  transition: all 0.5s;

  .mouse-function {
    display: flex;
    font-size: 20px;
    height: 45px;
    line-height: 45px;
    padding: 0px 10px;
    gap: 15px;
    color: @font_gray;
    justify-content: center;
    cursor: pointer;
    border-radius: @border_radius_2;
    transition: all 0.5s;

    &:hover {
      background: @basicselect;
      transition: all 0.5s;
    }

    span:nth-child(1) {
      display: block;
      font-size: 20px;
    }

    span:nth-child(2) {
      display: block;
      font-size: 20px;
    }
  }

  .mouse-function-dock {
    display: flex;
    font-size: 20px;
    height: 45px;
    line-height: 45px;
    text-decoration: line-through;
    padding: 0px 10px;
    gap: 15px;
    color: @font_gray;
    justify-content: center;
    // cursor: pointer;
    border-radius: @border_radius_2;
    transition: all 0.5s;
    opacity: 0.5;

    &:hover {
      // background: @basicselect;
      transition: all 0.5s;
    }

    span:nth-child(1) {
      display: block;
      font-size: 20px;
    }

    span:nth-child(2) {
      display: block;
      font-size: 20px;
    }
  }
}
</style>
